<template>
  <section>
    <v-dialog
      v-model="dialog"
      width="800px">
      <div class="dialog-container">
        <div class="dialog-header">
          <h2>New HD Transfer Ticket</h2>
          <div class="btn-container">
            <v-button
              size="small"
              @click="dialog = false">Cancel</v-button>
            <v-button
              size="small"
              type="primary"
              @click="handlerCreate">Create</v-button>
          </div>
        </div>
        <el-form
          ref="form"
          :model="formData"
          :rules="rules">
          <div class="dialog-content flex">
            <div class="left">
              <div class="form-item">
                <!--              <span>Assignee</span>-->
                <el-form-item
                  prop="assignee_id"
                  label="Assignee">
                  <v-select
                    v-model="formData.assignee_id"
                    :disabled="formData.assignee_id>0"
                    :list="globalOptions.assignee" />
                </el-form-item>
              </div>
              <div class="form-item">
                <!--              <span>Customer</span>-->

                <el-form-item
                  prop="customer_id"
                  label="Customer">
                  <el-select
                    v-if="form.customer_id"
                    v-model="form.cs_name"
                    disabled
                    size="small"
                  >
                    <el-option
                      :label="form.cs_name"
                      :value="form.cs_name"></el-option>
                  </el-select>
                  <v-select
                    v-else
                    v-model="formData.customer_id"
                    remote
                    nameGroup
                    :remoteMethod="remoteMethodUser"
                    labelKey="isrd_nm"
                    :list="customerOptionsUser"
                    :clearable="true" />
                </el-form-item>
              </div>
            </div>
            <div class="right">
              <div class="form-item">
                <!--              <span>Transfer Amount</span>-->
                <el-form-item
                  prop="money"
                  label="Transfer Amount">
                  <v-input
                    v-model="formData.money"
                    :integerCount="6"
                    money />
                </el-form-item>
              </div>
              <div class="form-item">
                <!--              <span>Bank Account Holder</span>-->
                <el-form-item
                  prop="card_holder"
                  label="Bank Account Holder">
                  <v-input
                    v-model="formData.card_holder"
                    uppercase />
                </el-form-item>
              </div>
              <div class="form-item">
                <!--              <span>Bank</span>-->
                <el-form-item
                  prop="bank_code"
                  label="Bank">
                  <v-select
                    v-model="formData.bank_code"
                    valueKey="bank_code"
                    labelKey="bank_name"
                    :list="bankList" />
                </el-form-item>
              </div>
              <div class="form-item">
                <!--              <span>Bank Account No.</span>-->
                <el-form-item
                  prop="card_number"
                  label="Bank Account No.">
                  <v-input v-model="formData.card_number" />
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </v-dialog>
    <send-email-sms
      ref="send-email-sms"
      :initContent="initContent"
      :emailListTitle="emailListTitle"
      :emailTitle="emailTitle"
      :form="customerData"
      updateContent
      @send="handlerSend"
      @skip="handlerSend"></send-email-sms>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {createCreditTicket, getTransferContent} from '@/api/ticket'
import {getBanksList} from '@/api/credits'
import {mapActions, mapState} from 'vuex'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'

export default {
  name: 'NewCreditTicket',
  components:{
    SendEmailSms
  },
  mixins: [MixinOptions, MixinRules],
  props:{
    form:{
      type:Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialog:false,
      formData: {
        assignee_id: '',
        customer_id: '',
        money: '',
        card_holder: '',
        bank_code: '',
        card_number: '',
        content: '',
        is_send: 0
      },
      banks: [],
      initContent: '',
      emailListTitle: '',
      emailTitle: '',
      customerData: {}
    }
  },
  computed: {
    ...mapState('common', ['customerOptionsPhone','customerOptionsUser','customerOptionsEmail']),
  },
  watch:{
    form:{
      immediate:true,
      handler(val){
        let {bank_holder,bank_code,bank_number,customer_id}=val
        this.formData.card_holder =bank_holder
        this.formData.customer_id =customer_id
        this.formData.bank_code =bank_code
        this.formData.card_number =bank_number
      }
    },
    'formData.customer_id':{
      immediate: true,
      handler(val){
        if(Array.isArray(this.customerOptionsUser) && this.customerOptionsUser.length){
          let res = this.customerOptionsUser.filter(item => item.id == val)
          this.customerData =  res[0] || {}
        }else{
          this.customerData = this.form || {}
        }
      }
    }
  },
  created() {
    let name = localStorage.getItem('cs_name')
    let arr = this.globalOptions.assignee||[]
    arr.some(item=>{
      if(item.name==name)
        this.formData.assignee_id = item.id
    })
  },
  methods: {
    ...mapActions('common', ['setProductId', 'getCustomerOptionsPhone','setCustomerOptionNUll','getCustomerOptionsEmail','getCustomerOptionsUser']),

    remoteMethodUser(query) {
      if (query !== '') {
        this.getCustomerOptionsUser(query)
      } else {
        this.setCustomerOptionNUll()
      }
    },
    changeDialog() {
      this.dialog = !this.dialog
    },
    handlerCreate() {
      this.$refs.form.validate(valid => {
        if(valid) {
          this.network().getTransferContent()
          this.$refs['send-email-sms'].changeDialog()
        }
      })
    },

    handlerSend(content){
      if(content){
        this.formData.is_send = 1,
        this.formData.content = content
      }else{
        this.formData.is_send = 0,
        this.formData.content = this.initContent
      }
      this.$refs['send-email-sms'].changeDialog()
      this.network().createCreditTicket()
      this.setCustomerOptionNUll()
    },

    network() {
      return {
        getBanksList: async () => {
          const { data } = await getBanksList()
          this.banks = data
        },
        createCreditTicket: async () => {
          const { data } = await createCreditTicket(this.formData)
          this.changeDialog()
          this.$router.push({
            path: '/tickets/detail',
            query: {
              ticket_id: data.id
            }
          })
        },

        getTransferContent: async () => {
          const {data} = await getTransferContent({
            customer_id: this.formData.customer_id
          })
          const {content, email_list_title, email_title} = data
          this.initContent = content
          this.initContent = this.initContent.replaceAll('{money}',this.formData.money)
          this.initContent = this.initContent.replaceAll('{holder}',this.formData.card_holder)
          let bank = this.getBankOptionName(this.formData.bank_code)
          this.initContent = this.initContent.replaceAll('{bank}',bank)
          this.initContent = this.initContent.replaceAll('{bank_number}',this.formData.card_number)
          this.emailListTitle = email_list_title
          this.emailTitle = email_title
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
    padding: 15px;
    color: #616266;
    // h2 {
    //   font-size: 24px;
    // }
    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 -15px;
      padding: 0 15px 5px 15px;
      border-bottom: 1px solid #dddfe7;
      h1 {
        font-size: 24px;
      }
    }
    .dialog-content {
      padding-top: 15px;
      & > div {
        flex: 1;
      }
      .left {
        margin-top: -15px;
        padding-right: 15px;
        padding-top: 15px;
        border-right: 1px solid #dddfe7;
      }
      .right {
        padding-left: 15px;
      }
    }
  }
.el-select {
  width: 100%;
  /deep/ .el-input__prefix {
    display: flex;
    align-items: center;
    padding-left: 3px;
    height: 100%;
  }
  .svg-inline--fa {
    font-size: 16px;
  }
  .el-input__suffix-inner{
    i{
      height: 32px;
      line-height: 32px;
    }
  }
}
</style>
